import { render, staticRenderFns } from "./UrunCardItem.vue?vue&type=template&id=85de659a&scoped=true"
import script from "./UrunCardItem.vue?vue&type=script&lang=js"
export * from "./UrunCardItem.vue?vue&type=script&lang=js"
import style0 from "./UrunCardItem.vue?vue&type=style&index=0&id=85de659a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85de659a",
  null
  
)

export default component.exports